var map = {
	"./AnandLingam.jpg": 30659,
	"./Aveen_Umashankar.jpg": 15654,
	"./Deepa_Bhat.jpg": 48809,
	"./Dr Abhilasha S.jpg.jpeg": 24060,
	"./Dr Mohit M.jpg.jpeg": 89545,
	"./Dr-rohit.jpg": 93531,
	"./Dr-yeshodha-s-mahesh.jpg": 17015,
	"./Dr.Chandan.jpg": 57667,
	"./Dr.Soumya.jpg": 97892,
	"./Dr.Srinivas_BV.jpg": 72756,
	"./Jyothirmayi.jpg": 78788,
	"./RAMESH_SINGH.jpg": 55479,
	"./RAVIHS.jpeg": 80525,
	"./SNEHA.jpeg": 5689,
	"./Satyanarayana.jpg": 32522,
	"./Suman.jpeg": 76550,
	"./SushmaKrishnamurthy.jpg": 57770,
	"./VIJAYKUMAR.jpg": 53906,
	"./aathira-ravindranath.png": 42234,
	"./aathira_ravindranath.jpg": 70775,
	"./abhilasha-1.jpeg": 39256,
	"./abhilasha-22.webp": 71096,
	"./abhilasha.jpg": 78397,
	"./ajay.jpg": 79866,
	"./amala-new.jpeg": 82306,
	"./amala.jpg": 92478,
	"./amritha-rao.jpg": 43788,
	"./amritha.jpg": 6007,
	"./anand-jayaram.jpg": 75043,
	"./anand-kumar-krishnappa.jpg": 73405,
	"./anand-lingan.jpg": 3392,
	"./anand-lingan1.jpg": 7723,
	"./anandLingan.jpeg": 15556,
	"./anil-b-jalan.png": 50666,
	"./anil-jalan.jpg": 17368,
	"./anjali-bp.jpg": 44382,
	"./anjana.jpg": 26839,
	"./anusha-new.jpg": 90192,
	"./aravind.jpg": 74379,
	"./archana-m.jpeg": 49877,
	"./archana.jpg": 14871,
	"./arif-doc-new.jpg": 91815,
	"./arif.jpg": 91594,
	"./arif_1.jpg": 61277,
	"./arpitha-dr-new.jpg": 99912,
	"./arun-raikar.jpg": 41864,
	"./ashika-new.JPG": 51769,
	"./ashika_r_prabhu.jpeg": 90866,
	"./ashmitha-shetty-new.png": 26372,
	"./ashmitha-shetty.jpg": 61557,
	"./ashmitha_shetty_new.png": 25662,
	"./ashoka-shetty-1.jpg": 6004,
	"./ashoka-shetty.jpg": 4981,
	"./ashwini-s.jpg": 74669,
	"./avantika.jpg": 99239,
	"./avinash.jpg": 94973,
	"./balaji-new.png": 64671,
	"./bharathi-k-r-doc.jpeg": 58769,
	"./bharathi-ramesh.jpg": 72690,
	"./bhavya.jpg": 64265,
	"./bindu-new.jpg": 55191,
	"./bindu.jpg": 94745,
	"./chaitra-rangaswamy.jpg": 72260,
	"./chandrika-anand.jpg": 96322,
	"./chaya-s-m.jpg": 11879,
	"./chethan.jpg": 30207,
	"./chethana.jpeg": 94638,
	"./chva_deepak_chowdari.png": 29539,
	"./de.nisar-ahamed.jpg": 31600,
	"./de.shahana.jpg": 74118,
	"./deepak-gowda.jpg": 29945,
	"./deeya.jpg": 81824,
	"./devaraj-m.jpg": 97058,
	"./dinesh.jpg": 76156,
	"./divyasre.jpg": 30522,
	"./divyasree.jpg": 91426,
	"./doctor_avatar_female.webp": 77244,
	"./dr-anjali-b-p.jpg": 64927,
	"./dr-anjali.jpg": 24915,
	"./dr-anuja.jpg": 96341,
	"./dr-anusha-new.JPG": 16637,
	"./dr-anusha.jpeg": 79809,
	"./dr-apoorva.png": 91833,
	"./dr-archana-d-v.png": 36375,
	"./dr-arpitha-new.JPG": 10400,
	"./dr-arpitha.jpg": 45151,
	"./dr-arvind-new.JPG": 76309,
	"./dr-aveen-new.JPG": 94464,
	"./dr-bharath-ban.jpeg": 5535,
	"./dr-bharath-ban1.jpeg": 55554,
	"./dr-bharath-ban1.jpg": 5114,
	"./dr-bharath.jpg": 56138,
	"./dr-bharathi-ramesh.png": 52590,
	"./dr-chandan-new.jpg": 89221,
	"./dr-chaya-s-m-new.png": 63500,
	"./dr-chethana-new.JPG": 80213,
	"./dr-deepak-kavandur.jpeg": 86626,
	"./dr-deeya-c-b.jpg": 1509,
	"./dr-divyashree-d-new.png": 18612,
	"./dr-geetha-eshwar-pillai.png": 91446,
	"./dr-geetha-new.png": 23134,
	"./dr-hema-h-r.png": 10638,
	"./dr-inchara-ben.jpeg": 44520,
	"./dr-inchara-ben1.jpg": 4611,
	"./dr-javgal-suraj-new.png": 53244,
	"./dr-jayashree-venkatesh-new.png": 21035,
	"./dr-kalyan-reddy.jpeg": 79935,
	"./dr-kalyan-reddy.jpg": 46732,
	"./dr-kishore-yeruru-new.png": 23540,
	"./dr-kshma-kamath.png": 23642,
	"./dr-kusuma.jpg": 36974,
	"./dr-leelavathi-new.JPG": 5048,
	"./dr-likhitha.jpg": 57439,
	"./dr-manjunath-mysore.jpg": 44523,
	"./dr-manjunatha-new.JPG": 50919,
	"./dr-nandini-ban.jpg": 64441,
	"./dr-nandini-patil.jpeg": 26623,
	"./dr-nanditha-nandakumar.jpg": 69572,
	"./dr-nanditha-new.JPG": 67006,
	"./dr-nanditha.jpg": 75822,
	"./dr-nivedita.png": 85130,
	"./dr-padmapriya-g-new.png": 73886,
	"./dr-padmapriya.jpg": 72723,
	"./dr-padmashree-nagraju.png": 20040,
	"./dr-pavitra-ramanagar.jpg": 79057,
	"./dr-pooja-new.JPG": 49673,
	"./dr-poonima-new.JPG": 39469,
	"./dr-prashanth-kumar.png": 94173,
	"./dr-prashanth-l-new.png": 27645,
	"./dr-praveen-new.JPG": 38219,
	"./dr-preethi-gowda-new.png": 55190,
	"./dr-preeti-allum.png": 81330,
	"./dr-priyanka-ravi.jpg": 19333,
	"./dr-priyanka-vijay-new.jpg": 11123,
	"./dr-punitha-new.jpg": 96453,
	"./dr-punnetha.jpg": 33081,
	"./dr-raghu-new.JPG": 44120,
	"./dr-ramapriya-kalkunte-new.png": 36978,
	"./dr-ramapriya-kalkunte-new1.jpeg": 5296,
	"./dr-ramya-prakash.png": 6581,
	"./dr-rashmi-kishor-new.JPG": 19889,
	"./dr-rashmi-new.JPG": 58607,
	"./dr-rashmi.jpg": 10502,
	"./dr-rasika-ravi-kumar.png": 66393,
	"./dr-ravi.jpg": 16250,
	"./dr-ravichandra-new.png": 73424,
	"./dr-raza-adoor.png": 39127,
	"./dr-sakolkar-shalmali-vilas.png": 54360,
	"./dr-sandhya-ban.jpeg": 95613,
	"./dr-sandhya-ban1.jpg": 23220,
	"./dr-seemasjmysore-new.png": 34512,
	"./dr-shahsikiran.jpg": 32092,
	"./dr-shalini-s-r.jpg": 22599,
	"./dr-shalini-s-r.png": 10738,
	"./dr-shashi-new.JPG": 18140,
	"./dr-shewtha-1.jpeg": 75212,
	"./dr-shewtha.jpg": 38974,
	"./dr-shilpa-mys.jpg": 74935,
	"./dr-shilpa-new.JPG": 56354,
	"./dr-shrithi.jpg": 59437,
	"./dr-shruthi-sh-new.png": 99794,
	"./dr-shruthi-sh.jpeg": 15621,
	"./dr-shubha-new.JPG": 85179,
	"./dr-spoorthi.jpg": 86249,
	"./dr-spurti-new.jpg": 36668,
	"./dr-srinath.png": 62941,
	"./dr-suman-new.png": 15053,
	"./dr-suman.jpg": 50817,
	"./dr-sunil-new.JPG": 76860,
	"./dr-sushma-new.JPG": 86271,
	"./dr-swathi-g.jpg": 16973,
	"./dr-tarangini.jpg": 77593,
	"./dr-taringini-durgappa-new.JPG": 48754,
	"./dr-thrupthi-new.JPG": 12963,
	"./dr-thrupthis.jpg": 594,
	"./dr-vandana.jpg": 94605,
	"./dr-veena-keerthi-new.jpeg": 77977,
	"./dr-veena-mysore.jpg": 40386,
	"./dr-veena-new.JPG": 75112,
	"./dr.madhusoodhan-new.jpeg": 92345,
	"./dr.priyanka.jpg": 79904,
	"./dr.sowmyaa.png": 22741,
	"./dr.sreeharsha.jpg": 2977,
	"./dr.suman.jpg": 48244,
	"./dr.varsha.jpg": 83500,
	"./dr.yeshoda-k-new.png": 66805,
	"./drSHREYASALVA.png": 42027,
	"./dr_aathira_ravindranath.jpg": 90626,
	"./drarunraykarnew.png": 29934,
	"./drashmitha-new.png": 71646,
	"./drbalaji-01.jpg": 80410,
	"./drbalajikc-01.jpg": 49362,
	"./drkavitakomandur.png": 4394,
	"./drmanjunath.jpg": 58414,
	"./drmanjunath1.jpg": 3670,
	"./drnarendrababunew.png": 48635,
	"./drnitinnayaknew.png": 53416,
	"./drparaasuraman.png": 79927,
	"./drpremalatha.jpeg": 10869,
	"./drramya-new.png": 1193,
	"./drrevati-new.png": 3034,
	"./drsahanan-new.png": 34896,
	"./drsumanthkumar.png": 31905,
	"./ekatha-c-n.png": 64930,
	"./femaledoc.png": 81764,
	"./gangam-new.jpg": 86922,
	"./gangam.jpg": 24342,
	"./geetha-pillai-1.jpg": 14199,
	"./geetha-pillai.jpg": 48848,
	"./harshitha-ramnagara.jpg": 63222,
	"./hema-h-r-new.jpg": 38594,
	"./hema-h-r-new1.jpeg": 63592,
	"./hema-h-r.jpg": 18990,
	"./hemalatha-ramanagar.jpg": 31902,
	"./indushree.jpeg": 16130,
	"./ishwarya.jpg": 5897,
	"./jacqueline-shah.jpg": 20405,
	"./jalajakshi.jpg": 39829,
	"./jamunashree.jpeg": 68190,
	"./javagal-s-suraj.jpg": 24076,
	"./jaya-kiran-new.jpg": 92271,
	"./jaya-kiran.png": 86317,
	"./jayanthi-durganna.jpg": 41998,
	"./jayanthi-new.png": 77246,
	"./jayanthi.jpg": 91782,
	"./jayashree.jpg": 57372,
	"./joewin-monteiro.jpg": 8699,
	"./kalyan-reddy.png": 63354,
	"./kav.jpg": 57624,
	"./kavitha-dental.jpeg": 66334,
	"./kavya-t.jpg": 6757,
	"./kavya.jpg": 82099,
	"./kavya_diet.jpg": 43622,
	"./kavyakrishnappa.jpg": 45962,
	"./kckavitha.jpg": 58713,
	"./keerthi-rajendra.jpg": 81368,
	"./kishore-yerur-new.jpg": 76376,
	"./kishore-yerur.jpg": 52589,
	"./kshama-kamath.jpg": 84714,
	"./kshma-kmth-new.png": 55516,
	"./lakshmi-dr.jpg": 12444,
	"./lakshmi-dr1.jpg": 41344,
	"./laxman-dr.jpg": 97421,
	"./leelvathi.jpg": 23857,
	"./leelvathi1.jpg": 60330,
	"./likhitha-ban.jpeg": 20642,
	"./likita-doc.png": 98112,
	"./lokeshwari-1.jpeg": 89220,
	"./lokeshwari-22.webp": 15719,
	"./lokeshwari.jpg": 80376,
	"./madhu-muddaiha.jpg": 4945,
	"./madhu-muddaihaa.jpeg": 14555,
	"./madhu-naidu.jpg": 21040,
	"./madhu-ramanagara.jpg": 44766,
	"./madhu.jpg": 8434,
	"./madhusoodan-old.jpg": 47901,
	"./madhusoodan.jpg": 76865,
	"./manasa-c.jpg": 96861,
	"./manjunatha.jpg": 5490,
	"./manjush-halbhavi.jpg": 11133,
	"./manjusha-nambiar.jpg": 27312,
	"./manjusha1.jpg": 36110,
	"./meena-b-m.jpg": 50101,
	"./meena-bm.png": 2754,
	"./mohit-m-1.webp": 5075,
	"./mohit-m.jpg": 6272,
	"./mr-arvind.png": 58004,
	"./nagarathnamma.jpg": 6955,
	"./nagendra-kumar-new.png": 18700,
	"./nagendra-kumar.jpg": 91409,
	"./nagendra-prasad.jpg": 67250,
	"./nandini-doc.png": 1028,
	"./nandita1.jpg": 89910,
	"./nanditha-m.jpg": 94654,
	"./narendra-babu.jpg": 39371,
	"./naveen-k-s.jpg": 57489,
	"./navneeth.jpg": 82505,
	"./neethu-priya-k.jpeg": 53034,
	"./niby-j-elackatt.jpg": 55469,
	"./nirmal-raj.jpg": 70430,
	"./nirmal1.jpg": 19477,
	"./nishan.jpg": 42185,
	"./nithin-r.jpeg": 98439,
	"./nitin-nayak.jpg": 44923,
	"./padmapriya-new.png": 53997,
	"./padmashree-doc-kc.jpg": 25526,
	"./pallavi.jpg": 62829,
	"./pallavi1.jpg": 27683,
	"./pavi.jpg": 70794,
	"./pooja_n_swamy.jpg": 53531,
	"./poornima.jpg": 87810,
	"./prabhakaran.jpg": 17035,
	"./prakash-babu.jpg": 85067,
	"./pramod-new.png": 77931,
	"./pramod.jpg": 16425,
	"./pramod.png": 64290,
	"./prashanth-inna.jpg": 93407,
	"./prashanth.jpg": 21301,
	"./praveen-n.jpeg": 69423,
	"./praveen.jpg": 91590,
	"./praveez-ahmed.jpg": 17951,
	"./preethi-allum.jpg": 51303,
	"./preethi-gowda.jpg": 3460,
	"./premalatha.jpeg": 16706,
	"./priyanka-new.jpg": 15129,
	"./priyanka.jpg": 9464,
	"./puspanjali-ramanagara.jpg": 73739,
	"./raghu.jpeg": 6214,
	"./rajeshwari-s.jpg": 65925,
	"./rakesh-mysore.jpeg": 60896,
	"./ramapriya-kalkunte.jpg": 44500,
	"./rame-gowda.JPG": 81357,
	"./rame-gowda.png": 83271,
	"./ramya_shankar.jpg": 92568,
	"./ranjitha-new.png": 864,
	"./rashmi-kishore.png": 8903,
	"./rashmi-t-s-new.jpg": 12679,
	"./rashmiKishore.jpeg": 13639,
	"./rashmiKishore.jpg": 66210,
	"./rashmikishore-01.jpg": 33217,
	"./rasika.jpeg": 1579,
	"./ravi-hiremagalur.png": 64668,
	"./ravichandra.jpg": 13046,
	"./revathi.png": 67356,
	"./roopa-pateel-dr.jpg": 59893,
	"./sabeena-taj.jpg": 59560,
	"./sachin-dharwadkar.jpg": 31817,
	"./sagetya.jpg": 60938,
	"./sahana-ramanagara.jpg": 33001,
	"./sahana.png": 68756,
	"./santhosh-ramanagara.jpg": 71898,
	"./santhosh_kumar.jpeg": 70232,
	"./santhoshkumar-1.jpeg": 92141,
	"./santosh-olety-sathyanarayana.jpg": 75318,
	"./saraswati-vishwanatha.png": 86649,
	"./saraswati-viswanathan.jpg": 97904,
	"./sathish-babu.jpg": 90310,
	"./satosh-babu-new.png": 6136,
	"./satosh-babu-new1.png": 6876,
	"./shalini-narayan.jpg": 65787,
	"./shalini-new.jpg": 63456,
	"./shalmali-old.jpg": 21630,
	"./shalmali.jpeg": 20322,
	"./shalmali.jpg": 52468,
	"./shankar-singh.jpg": 95322,
	"./shasthara.jpg": 69749,
	"./shekar-subbaiah-new.jpeg": 10993,
	"./shekar-subbaiah-old.jpg": 46906,
	"./shekar-subbaiah.jpeg": 19224,
	"./shekar-subbaiah.jpg": 39901,
	"./shilpa-nadig.jpeg": 53718,
	"./shilpa_n_vijay.jpg": 53594,
	"./shivachandra.jpg": 98336,
	"./shreenath-bangalore.jpg": 11142,
	"./shreyas.jpg": 21662,
	"./shristi-v.png": 44864,
	"./shruthi-ramanagar.jpg": 43340,
	"./shubha-mysore.jpg": 72824,
	"./shwetha-b-m.jpeg": 90804,
	"./siddarth_warad.jpeg": 97486,
	"./siri-gowri-s.jpeg": 11558,
	"./smita.jpg": 26084,
	"./smitha-shetty.jpg": 22460,
	"./sneha1.jpg": 84064,
	"./soumya-arudi-nagarajan.jpg": 83024,
	"./soumya-jpg.jpg": 61696,
	"./spurtii.jpeg": 15,
	"./spurtii.jpg": 88506,
	"./sree-harsha.png": 47509,
	"./srushti.jpg": 54248,
	"./subramya-new.jpg": 57161,
	"./subramya.jpg": 87410,
	"./suchitra-sl.jpg": 29988,
	"./sumalatha_k_b.jpeg": 15203,
	"./suman-r-k.jpg": 95140,
	"./sunayana-nagendra-s-1.jpg": 4924,
	"./sunayana-nagendra-s.jpg": 87853,
	"./suneel.jpg": 42865,
	"./suneetha.jpeg": 64241,
	"./sunil-mysore-new.jpg": 67937,
	"./supriya-bhandage.jpeg": 71360,
	"./sushma.jpg": 74612,
	"./sushmitha-r.png": 56332,
	"./swaroop.jpeg": 94121,
	"./swathi-g-new.png": 6211,
	"./swathi-g-old.png": 36506,
	"./swathi-g.png": 52323,
	"./swathi1.jpg": 66750,
	"./swatihkmysore-new.png": 21489,
	"./tarun-javeli.jpeg": 67940,
	"./testDoctor.png": 20458,
	"./thrupthi-new.jpg": 86199,
	"./tripti-mirza-new.jpg": 5663,
	"./trupti-1.jpg": 77643,
	"./varun-new.jpg": 89125,
	"./varun_ramnagara.jpg": 45300,
	"./veena.jpg": 82515,
	"./veerendarsingh-b.jpeg": 9733,
	"./vibha.jpg": 16408,
	"./vibha1.jpg": 3435,
	"./vinay-ja.jpg": 93133,
	"./vinay-jadh.png": 13531,
	"./vinay-jadhav.jpg": 14579,
	"./vykunta-raju-new.jpg": 87608,
	"./vykunta-raju.jpg": 68434,
	"./vyshakha-chikkanagoudar.png": 47742,
	"./yashaswini.jpg": 56612,
	"./yashaswini1.jpg": 59897,
	"./yashodha-k-n.jpg": 94563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30621;